// extracted by mini-css-extract-plugin
module.exports = {"card":"_28iS5BNcQyWItGn7Clunnu","title":"_3zDkoyXWSDst0wt8EYJdSg","topic":"_3heyXGpNYjVXXfKZtERErw","content":"_3qhoyKQaQwsZswOZMEo4AW","value":"_46_TFtiIFGhj_8PEjvjhv"};